import(/* webpackMode: "eager" */ "/home/runner/work/all-inclusive-mono/all-inclusive-mono/apps/web/node_modules/next/dist/client/link.js");
